import { render, staticRenderFns } from "./UserPermissionHeader.vue?vue&type=template&id=b7ec9732"
import script from "./UserPermissionHeader.vue?vue&type=script&lang=js"
export * from "./UserPermissionHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports